import $ from "jquery";

const customizationModalSelector = ".product-popup-modal__product-customization";
const customizationModalSubmitSelector = '#product-customization-modal-confirm';
const customizationModalCloseSelector = '.product-popup-modal__toggle';
const customizationTextSelector = "#customization-text";
const customizationTextModelSelector = "#customization-text-model";
const customizationTextPreviewSelector = "#customization-text-preview";
const customizationStyleSelector = "#customization-styles";
const customizationStyleModelSelector = 'input[name="customization-style-model"]';
const customizationStyleModelCheckedSelector = 'input[name="customization-style-model"]:checked';
const customizationColorSelector = "#customization-colors";
const customizationColorModelSelector = 'input[name="customization-color-model"]';
const customizationColorModelCheckedSelector = 'input[name="customization-color-model"]:checked';
const customizationPositionSelector = "#customization-positions";
const customizationPositionModelCheckedSelector = 'input[name="customization-position-model"]:checked';
const customizationValueSelector = ".customization-value";
const customizationValueListSelector = ".customization-values";
const customizationPropertySelector = "input.customization-property";


export const intProductCustomization = () => {
    const customizationModal = $(customizationModalSelector);
    if(customizationModal) {
        initCustomizationTextModel();
        initCustomizationStyleModel();
        initCustomizationColorModel();
        initCustomizationSubmit();
    }
}

const initCustomizationTextModel = () => {
    const customizationModal = $(customizationModalSelector);
    const submitButton = customizationModal.find(customizationModalSubmitSelector);
    $(customizationTextModelSelector).on('keyup', function() {
        let val = $(this).val();
        if(!val) {
            val = $(this).attr('placeholder') ?? '';
            submitButton.prop("disabled", true);
            clearCustomizationValues();
        } else {
            submitButton.prop("disabled", false);
        }
        const new_val = val.toString().toUpperCase();
        $(customizationTextPreviewSelector).html(new_val);
    });
}

const initCustomizationStyleModel = () => {
    $(customizationStyleModelSelector).on('change', function() {
        const selectedFont = $(this).data('font');
        if(selectedFont) {
            $(customizationTextPreviewSelector).css('font-family', selectedFont.toString());
        }
    });
}

const initCustomizationColorModel = () => {
    $(customizationColorModelSelector).on('change', function() {
        const selectedColor = $(this).data('color');
        if(selectedColor) {
            $(customizationTextPreviewSelector).css('color', selectedColor.toString());
        }
    });
}

const initCustomizationSubmit = () => {
    const customizationModal = $(customizationModalSelector);
    const closeButton = customizationModal.find(customizationModalCloseSelector);
    $(customizationModalSubmitSelector).on('click', function() {
        const text = $(customizationTextModelSelector).val()?.toString() ?? '';
        const style = $(customizationStyleModelCheckedSelector).val()?.toString() ?? '';
        const position = $(customizationPositionModelCheckedSelector).val()?.toString() ?? '';
        const color = $(customizationColorModelCheckedSelector).val()?.toString() ?? '';
        setCustomizationValues(text.toUpperCase(), style, position, color);
        closeButton.trigger('click');
    });
}

const clearCustomizationValues = () => {
    $(customizationPropertySelector).each(function() {
        $(this).val('').prop("disabled", true);
    });
    $(customizationValueSelector).each(function () {
        $(this).find('.value').html('');
    });
    $(customizationValueListSelector).addClass('hidden');
}

const setCustomizationValues = (
    text: string,
    style: string,
    position:string,
    color: string,
) => {
    $(customizationTextSelector)
        .val(text)
        .prop("disabled", false)
        .next(customizationValueSelector)
        .find('.value')
        .html(text);
    $(customizationStyleSelector)
        .val(style)
        .prop("disabled", false)
        .next(customizationValueSelector)
        .find('.value')
        .html(style);
    $(customizationPositionSelector)
        .val(position)
        .prop("disabled", false)
        .next(customizationValueSelector)
        .find('.value')
        .html(position);
    $(customizationColorSelector)
        .val(color)
        .prop("disabled", false)
        .next(customizationValueSelector)
        .find('.value')
        .html(color);
    $(customizationValueListSelector).removeClass('hidden');
}